import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { getQuery } from '@src/utils/utils';

class Iframe extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    state = {
        iframeHeight: 0,
    };

    componentDidMount() {
        window.addEventListener(
            'message',
            event => {
                if (event?.data?.height && parseInt(event?.data?.height)) {
                    this.setState({
                        iframeHeight: parseInt(event?.data?.height),
                    });
                }
            },
            false,
        );
    }

    /**
     * 渲染组件
     */
    render() {
        const { content } = this.props;
        const { iframeHeight } = this.state;
        let url = getQuery(location.href, 'iframeUrl');
        let flag = false;

        content.forEach(item => {
            if (url.includes(item.iframeUrl)) {
                flag = true;
            }
        });

        if (!flag) {
            url = '';
        }

        return (
            <iframe scrolling="no" frameBorder="0" width="1000px" height={`${iframeHeight}px`} border="0" src={url} />
        );
    }
}

export default errorBoundary(Iframe);
